import { useMemo } from 'react';

import { MembershipFragment } from '@occc/graphql';
import { LinkItem } from '@occc/ui-design-system';

import { routeCreator, displayFullName } from '../utils';

export const useLinks: (member: MembershipFragment | undefined) => LinkItem[] = (member) => {
  return useMemo(() => {
    if (!member) {
      return [];
    }
    return [
      {
        to: routeCreator.base(),
        label: 'Members',
      },
      {
        key: routeCreator.details(member.id),
        label: displayFullName(member),
      },
    ];
  }, [member]);
};
